/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface GrafanaVerifyInternalGrafanaVerifyGet$Params {
  auth_token?: string | null;
}

export function grafanaVerifyInternalGrafanaVerifyGet(
  http: HttpClient,
  rootUrl: string,
  params?: GrafanaVerifyInternalGrafanaVerifyGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, grafanaVerifyInternalGrafanaVerifyGet.PATH, 'get');
  if (params) {
    rb.query('auth_token', params.auth_token, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<any>;
    }),
  );
}

grafanaVerifyInternalGrafanaVerifyGet.PATH = '/internal/grafana-verify';
